import { takeEvery, fork, put, all, call } from 'redux-saga/effects';

import { baseUrl, customHeaders } from '../../../../Containers/Config/index.js';
import { UPDATE_CLIENTS_CUSTOMER, UPDATE_CLIENTS_CUSTOMER_SUCCESS, UPDATE_CLIENTS_CUSTOMER_ERROR } from './../../actionType.js';
import apiCall from '../../apiCall';
import cogoToast from 'cogo-toast';
import { Constant } from '../../../../Containers/Helpers/constant.js';

function* updateClientsCustomer({ payload }) {
  try {
    const response = yield call(apiCall, {
      url: `${baseUrl}/admin/clientCustomers`,
      method: 'PUT',
      headers: {
        Authorization: Constant?.CLIENT_TOKEN,
        ...customHeaders,
      },
      data: payload.data,
    });

    if (response.status === 200) {
      cogoToast.success(response?.data?.message);
      yield put({
        type: UPDATE_CLIENTS_CUSTOMER_SUCCESS,
        payload: response?.data,
      });
    } else {
      cogoToast.error(response?.response?.data?.message);
      yield put({
        type: UPDATE_CLIENTS_CUSTOMER_ERROR,
        payload: response.data.message,
      });
    }
  } catch (error) {
    yield put({ type: UPDATE_CLIENTS_CUSTOMER_ERROR, payload: error });
  }
}

export function* watchUpdateClientsCustomer() {
  yield takeEvery(UPDATE_CLIENTS_CUSTOMER, updateClientsCustomer);
}

function* updateClientsCustomerSaga() {
  yield all([fork(watchUpdateClientsCustomer)]);
}

export default updateClientsCustomerSaga;
